import styled from "@emotion/styled";
import { Flex } from "@otrium/core";

const Wrapper = styled(Flex)`
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space.space16};
  width: 100%;
`;

export { Wrapper };
